module.exports = __webpack_public_path__ + "img/production.151cee1a.png";